import { ReactNode } from "react";
// mui
import RtlMuiThemeProvider from "./RtlMuiThemeProvider";
import { ThemeModeProvider } from "../../theme/ThemeModeContext";
// toast alert
import { SnackbarProvider } from "notistack";
// redux
import { Provider } from "react-redux";
import { store } from "../../redux/store";
// react query
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import useMeta from "../../hooks/useMeta";

type Props = {
  children: ReactNode;
};
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      gcTime: 0,
      refetchInterval: 0,
    },
  },
});

const Providers = ({ children }: Props) => {
  return (
    <Provider store={store}>
      <RtlMuiThemeProvider>
        <ThemeModeProvider>
          <SnackbarProvider maxSnack={3} autoHideDuration={5000}>
            <QueryClientProvider client={queryClient}>
              {children}
            </QueryClientProvider>
          </SnackbarProvider>
        </ThemeModeProvider>
      </RtlMuiThemeProvider>
    </Provider>
  );
};

export default Providers;
